import * as React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Button, Toast, ToastBody, ToastHeader, Table, Row, Col, Input, Label, Collapse } from 'reactstrap';
import { useAppDispatch } from '../../hooks/index';
import { ActionResponseRequest, AccountWithCode, BypassStatus, MultipleBypassResponseRequest, requestBypass, sendBypassResponse, sendMultipleBypassResponse } from '../../redux/EventsSlice';
import 'react-dropdown-tree-select/dist/styles.css'
import enums from '../../utils/enums';
import { loadConcept } from '../../redux/ConceptSlice';
import utilityHelper from '../../utils/utilityHelper';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';


const BypassStatusViewer = (props: { userRole: string, statusList: Array<BypassStatus>, status: string, afrId : string }) => {
    const dispatch = useAppDispatch();

    const displayStatus = enums.bypassStatusDisplay[props.status];
    const [balanceSheet, setBalanceSheet] = useState<Array<BypassStatus>>([]);
    const [revenues, setRevenues] = useState<Array<BypassStatus>>([]);
    const [expenditures, setExpenditures] = useState<Array<BypassStatus>>([]);
    const [hasEntries, setHasEntries] = useState(false);
    const [selectedAccounts, setSelectedAccounts] = useState<Array<BypassStatus>>([]);

    const [showRejectionReason, setShowRejectionReason] = React.useState<boolean>(false);
    const [actionReason, setActionReason] = React.useState<string>('');


    const handleBypassActionClick = function (responseType : string) {
        switch (selectedAccounts.length) {
            case 0:
                break;

            case 1:
                var args: ActionResponseRequest = {
                    actionCode: "foo",
                    connector: props.afrId,
                    response: responseType,
                    recipientId: 'noone',
                    reason: actionReason.length > 0 ? actionReason : null
                }
                var acct = selectedAccounts[0];
                args.actionCode = acct.displayCode;
                if (acct.requestor && acct.requestor.login) {
                    args.recipientId = acct.requestor.login;
                }
                dispatch(sendBypassResponse(args));
                break;

            default:
                var multiArgs: MultipleBypassResponseRequest = {
                    multipleRequest: []
                }
                for (var acct of selectedAccounts) {
                    var singleArg: ActionResponseRequest = {
                        actionCode: "foo",
                        connector: props.afrId,
                        response: responseType,
                        recipientId: 'noone',
                        reason: actionReason.length > 0 ? actionReason : null
                    }
                    singleArg.actionCode = acct.displayCode;
                    if (acct.requestor && acct.requestor.login) {
                        singleArg.recipientId = acct.requestor.login;
                    }
                    multiArgs.multipleRequest.push(singleArg);
                }
                dispatch(sendMultipleBypassResponse(multiArgs));
                break;
        }
        setSelectedAccounts([]);
    }
    const handleBypassApproveClick = function (event: any) {
        handleBypassActionClick('APPROVED');
    }
    const handleBypassRejectClick = function () {
        handleBypassActionClick('REJECTED');
        setShowRejectionReason(false);
    }
    const handleBypassWithdrawClick = function () {
        handleBypassActionClick('WITHDRAWN');
    }

    const handleBypassRejectReasonClick = function () {
        setShowRejectionReason(true);
    }

    const getAfrYear = function () {
        if (!props.afrId) {
            return 2019;
        }
        var parts = props.afrId.split("^");
        if (parts.length < 2) {
            return 2019;
        }
        return parseInt(parts[1]);
    }

    const handleBypassClick = function (event: any) {
        var conceptId = event.target.name;
        var idx = conceptId ? conceptId.indexOf(".") : -1;
        if (idx > 0 && conceptId.length === 6) {
            // This is an expenditures concept
            conceptId = conceptId.substring(0, idx);
        }

        dispatch(loadConcept({
            conceptId: "AccountCode_" + conceptId,
            taxonomyType: TaxonomyTypeEnum.AFR,
            afrYear: getAfrYear()
        }));
        return false;
    }

    const isSelected = function (opt: BypassStatus) {
        if (selectedAccounts.length === 0) {
            return false;
        }
        var filteredSet = selectedAccounts.filter(bp => bp.displayCode === opt.displayCode);
        return filteredSet.length > 0;
    }

    const getStatusForCode = function (code: string) {
        for (var bpstat of props.statusList) {
            if (bpstat.displayCode === code) {
                return bpstat;
            }
        }
        return null;
    }

    const removeSelection = function (acctCode : string) {
        let newSelections: Array<BypassStatus> = [];

        for (var selAcct of selectedAccounts) {
            if (selAcct.displayCode != acctCode) {
                newSelections.push(selAcct);
            }
        }
        setSelectedAccounts(newSelections);
    }

    const addSelection = function (acctCode : string) {
        var bpstat = getStatusForCode(acctCode);
        if (bpstat) {
            if (!isSelected(bpstat)) {
                setSelectedAccounts([...selectedAccounts, bpstat])
            }
        }
    }

    const handleChangeCheckbox = function (event: any) {
        if (event.target.checked === true) {
            addSelection(event.target.name);
        } else {
            removeSelection(event.target.name);
        }
    }

    const populateLists = function (sList: Array<BypassStatus>, status: string) {
        let bslist: Array<BypassStatus> = [];
        let revlist: Array<BypassStatus> = [];
        let exlist: Array<BypassStatus> = [];
        var entryCount = 0;
        for (var bypass of sList) {
//            var dcode = generateDisplayCode(bypass.account);
            if (bypass.status === status) {
                if (bypass.account.account < "3") {
                    bslist.push(bypass);
                    entryCount++;
                } else if (bypass.account.account < "5") {
                    revlist.push(bypass);
                    entryCount++;
                } else {
                    exlist.push(bypass);
                    entryCount++;
                }
            }
        }
        setBalanceSheet(bslist);
        setRevenues(revlist);
        setExpenditures(exlist);
        if (entryCount > 0) {
            setHasEntries(true);
        } else {
            setHasEntries(false);
        }
    }

    useEffect(function () {
        populateLists(props.statusList, props.status);
    }, [props.statusList,setBalanceSheet,setRevenues,setExpenditures]);


    const getEntryGivenRole = (stringKeyValue: string) => {

        var result: any = (<></>);
        if (hasEntries) {
            switch (stringKeyValue) {
                case 'APPROVED':
                    result = (<Row key={utilityHelper.generateGuid()} >
                        <Col className="d-flex justify-content-center pl-2 pr-3 py-3 my-2">
                            <Button key={utilityHelper.generateGuid()} type="button" disabled={selectedAccounts.length == 0} onClick={handleBypassWithdrawClick} >Withdraw</Button>
                        </Col>
                    </Row>);
                    break;

                case 'REJECTED':
                    result = (<Row key={utilityHelper.generateGuid()} >
                        <Col className="d-flex justify-content-center pl-2 pr-3 py-3 my-2">
                            <Button key={utilityHelper.generateGuid()} type="button" disabled={selectedAccounts.length == 0} onClick={handleBypassWithdrawClick} >Withdraw</Button>
                        </Col>
                    </Row>)
                    break;

                case 'PENDING':
                    result = (<Row key={utilityHelper.generateGuid()} >
                        <Col className="d-flex justify-content-center pl-2 pr-3 py-3 my-2">
                            <Button key={utilityHelper.generateGuid()} type="button" disabled={selectedAccounts.length == 0} onClick={handleBypassWithdrawClick} >Withdraw</Button>
                        </Col>
                    </Row>)
                    break;

                case 'APPROVEDA':
                    result = (<Row key={utilityHelper.generateGuid()} >
                        <Col className="d-flex justify-content-center pl-2 pr-3 py-3 my-2">
                            <Button key={utilityHelper.generateGuid()} type="button" disabled={selectedAccounts.length == 0} onClick={handleBypassRejectClick} >Reject</Button>
                        </Col>
                        <Col className="d-flex justify-content-center pl-2 pr-3 py-3 my-2">
                            <Button key={utilityHelper.generateGuid()} type="button" disabled={selectedAccounts.length == 0} onClick={handleBypassWithdrawClick} >Withdraw</Button>
                        </Col>
                    </Row>)
                    break;

                case 'REJECTEDA':
                    result = (<Row key={utilityHelper.generateGuid()} >
                        <Col className="d-flex justify-content-center pl-2 pr-3 py-3 my-2">
                            <Button key={utilityHelper.generateGuid()} type="button" disabled={selectedAccounts.length == 0} onClick={handleBypassApproveClick} >Approve</Button>
                        </Col>
                        <Col className="d-flex justify-content-center pl-2 pr-3 py-3 my-2">
                            <Button key={utilityHelper.generateGuid()} type="button" disabled={selectedAccounts.length == 0} onClick={handleBypassWithdrawClick} >Withdraw</Button>
                        </Col>
                    </Row>)
                    break;

                case 'PENDINGA':
                    result = (<Row key={utilityHelper.generateGuid()} >
                        <Col className="d-flex justify-content-center pl-2 pr-3 py-3 my-2">
                            <Button key={utilityHelper.generateGuid()} type="button" disabled={selectedAccounts.length == 0} onClick={handleBypassApproveClick} >Approve</Button>
                        </Col>
                        <Col className="d-flex justify-content-center pl-2 pr-3 py-3 my-2">
                            <Button key={utilityHelper.generateGuid()}
                                type="button" disabled={selectedAccounts.length == 0}
                                onClick={handleBypassRejectReasonClick} >Reject</Button>
                        </Col>
                        <Col className="d-flex justify-content-center pl-2 pr-3 py-3 my-2">
                            <Button key={utilityHelper.generateGuid()} type="button" disabled={selectedAccounts.length == 0} onClick={handleBypassWithdrawClick} >Withdraw</Button>
                        </Col>
                    </Row>)
                    break;

                default:
                    break;
            }
        }
        return result;
    }


    


    return (
        <React.Fragment>
            <Col sm="12" >
                <Toast className="auditDetail">
                    <ToastHeader className="auditDetail">{displayStatus} Bypass Requests</ToastHeader>
                    <ToastBody>
                        <Collapse isOpen={showRejectionReason == false}>
                            <Table className="table" >
                                <thead className="scrollable-table-header thead-dark">
                                    <tr>
                                        <th className="col-1">Balance Sheet</th>
                                        <th className="col-1">Revenues</th>
                                        <th className="col-1">Expenditures</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>
                                            <Col>
                                                {balanceSheet.map((option, idx) => (
                                                    <div>
                                                        <Label name={option.displayCode} className="ml-4" check>
                                                            <Input type="checkbox"
                                                                name={option.displayCode}
                                                                onChange={handleChangeCheckbox}
                                                                checked={isSelected(option)}
                                                            /><b>{option.displayCode}</b>
                                                        </Label>
                                                    </div>
                                                ))}
                                            </Col>
                                        </td>
                                        <td>
                                            <Col>
                                                {revenues.map((option, idx) => (
                                                    <div>
                                                        <Label name={option.displayCode} onClick={handleBypassClick} className="ml-4" check>
                                                            <Input type="checkbox"
                                                                name={option.displayCode}
                                                                onChange={handleChangeCheckbox}
                                                                checked={isSelected(option)}
                                                            /><b>{option.displayCode}</b>
                                                        </Label>
                                                    </div>
                                                ))}
                                            </Col>
                                        </td>
                                        <td>
                                            <Col  >
                                                {expenditures.map((option, idx) => (
                                                    <div>
                                                        <Label name={option.displayCode} onClick={handleBypassClick} className="ml-4" check>
                                                            <Input type="checkbox"
                                                                name={option.displayCode}
                                                                onChange={handleChangeCheckbox}
                                                                checked={isSelected(option)}
                                                            /><b>{option.displayCode}</b>
                                                        </Label>
                                                    </div>
                                                ))}
                                            </Col>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>

                            {getEntryGivenRole(props.status + (props.userRole === "ADMIN" ? "A" : ""))}
                        </Collapse>
                        <Collapse isOpen={showRejectionReason == true}>
                            <Row>
                                <Col>
                                    {/* //TODO add selected account code to verify its using the correct one*/}
                                    <Input type="textarea" value={actionReason} rows="10"
                                        onChange={(e) => setActionReason(e.currentTarget.value)} />
                                </Col>
                            </Row>
                            <Row>
                                <Col className="d-flex justify-content-center pl-2 pr-3 py-3 my-2">
                                    <Button key={utilityHelper.generateGuid()} type="button"
                                        disabled={selectedAccounts.length == 0}
                                        onClick={handleBypassRejectClick} >Reject</Button>
                                </Col>
                                <Col className="d-flex justify-content-center pl-2 pr-3 py-3 my-2">
                                    <Button key={utilityHelper.generateGuid()} type="button"
                                        disabled={selectedAccounts.length == 0}
                                        onClick={() => { setActionReason(""); setShowRejectionReason(false); }} >Cancel</Button>
                                </Col>
                            </Row>                        
                        </Collapse>

                    </ToastBody>
                </Toast>
            </Col>
        </React.Fragment>
        )
}

export default BypassStatusViewer;